import { useState } from "react";
import type { ProjectType } from "@reno-estimator/core";
import { StepShell } from "../ui/StepShell.js";
import { OptionCard } from "../ui/OptionCard.js";
import { ALL_PROJECT_TYPE_OPTIONS, POPULAR_PROJECT_TYPE_OPTIONS } from "../../lib/projectTypes.js";
import type { EstimatorFlow } from "../../state/useEstimatorFlow.js";

export function Step1ProjectType({ flow }: { flow: EstimatorFlow }) {
  const [showAll, setShowAll] = useState(false);
  const options = showAll ? ALL_PROJECT_TYPE_OPTIONS : POPULAR_PROJECT_TYPE_OPTIONS;

  return (
    <StepShell
      title="What are you renovating?"
      helpText="Pick the project that's closest to what you're planning. You can always start a new estimate for something else."
      showBack={false}
      onNext={flow.goNext}
      nextDisabled={!flow.projectType}
    >
      <div className="option-grid" role="radiogroup" aria-label="Project type">
        {options.map((opt) => (
          <OptionCard
            key={opt.id}
            name="project-type"
            value={opt.id}
            label={opt.label}
            icon={opt.icon}
            description={opt.supported ? undefined : "Basic estimate only - detailed pricing coming soon"}
            checked={flow.projectType === opt.id}
            onChange={(checked) => {
              if (checked) flow.selectProjectType(opt.id as ProjectType);
            }}
          />
        ))}
      </div>
      {!showAll ? (
        <button type="button" className="btn btn--link" onClick={() => setShowAll(true)}>
          Show all project types
        </button>
      ) : null}
    </StepShell>
  );
}
